// WebSocket endpoint
let isTransformerActive = false;
let isloopRunning = false;
const requestDataQueueFIFO = []; //{ points:points[], replacable: boolean}
let appLaumchPromiseResolve;
let singlePromiseResolve;
let singlePromiseReject;
let singlePromiseData;
let retryCount = 0;
let wsServerUrl = "";
const MAX_RETRY_COUNT = 3;

function debounce(func, timeout = 300) {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			func.apply(this, args);
		}, timeout);
	};
}

// WebSocket Connection
let wsConvertToWGS84;

export const initWebSocket = (serverUrl, site) => {
	// if(!serverUrl || serverUrl === "" ){
	//   console.warn("web socket server url is undefined or empty");
	//   return;
	// }
	wsServerUrl = serverUrl;
	wsConvertToWGS84 = new WebSocket(wsServerUrl);
	let resolve;
	// Connection opened
	wsConvertToWGS84.addEventListener("open", (event) => {
		console.log("WebSocket connection opened", event);
		resolve && resolve();
	});

	// WebSocket error event.
	wsConvertToWGS84.addEventListener("error", (error) => {
		isTransformerActive = false;
		isloopRunning = false;
		console.error("WebSocket error:", error);
	});

	// WebSocket close event.
	wsConvertToWGS84.addEventListener("close", (code, reason) => {
		isTransformerActive = false;
		isloopRunning = false;
		if (singlePromiseData && singlePromiseResolve && singlePromiseReject) {
			if (retryCount < MAX_RETRY_COUNT) {
				retryCount++;
				requestDataQueueFIFO.unshift({
					points: singlePromiseData,
					resolve: singlePromiseResolve,
					reject: singlePromiseReject,
				});
				runloop();
			} else {
				singlePromiseReject();
				singlePromiseResolve = undefined;
				singlePromiseReject = undefined;
				singlePromiseData = undefined;
				retryCount = 0;
			}
		}
	});

	wsConvertToWGS84.addEventListener("message", (event) => {
		const messageObj = JSON.parse(event.data);
		if (messageObj.eventName == "LAUNCHING_APP_FINISH") {
			isTransformerActive = true;
			appLaumchPromiseResolve && appLaumchPromiseResolve();
		}

		if (messageObj.eventName == "PROCESS_FINISH") {
			singlePromiseResolve && singlePromiseResolve(messageObj.data);
			singlePromiseResolve = undefined;
			singlePromiseReject = undefined;
			singlePromiseData = undefined;
			retryCount = 0;
		}

		if (messageObj.eventName == "CLOSING_APP_FINISH") {
			isTransformerActive = false;
			isloopRunning = false;
			singlePromiseResolve = undefined;
			singlePromiseReject = undefined;
			singlePromiseData = undefined;
			retryCount = 0;
		}
		if (messageObj.eventName == "FAIL") {
			isTransformerActive = false;
			isloopRunning = false;
			singlePromiseReject && singlePromiseReject();
			singlePromiseResolve = undefined;
			singlePromiseReject = undefined;
			singlePromiseData = undefined;
			retryCount = 0;
		}
	});
	return new Promise((_resolve) => {
		resolve = _resolve;
	});
};

const transformPoints = (points) => {
	return new Promise((resolve, reject) => {
		if (isTransformerActive) {
			singlePromiseResolve = resolve;
			singlePromiseReject = reject;
			singlePromiseData = points;
			wsConvertToWGS84.send(
				JSON.stringify({
					eventName: "PROCESS",
					data: {
						points: points,
					},
				}),
			);
		} else {
			reject();
			singlePromiseReject = undefined;
			singlePromiseResolve = undefined;
			singlePromiseData = undefined;
			retryCount = 0;
		}
	});
};

const recursive = (data) => {
	transformPoints(data.points)
		.then((transformedPoints) => {
			data.resolve(transformedPoints);
		})
		.catch((e) => {
			data.reject(e);
		})
		.finally(() => {
			const nextData = requestDataQueueFIFO.shift();
			if (nextData) {
				recursive(nextData);
			} else {
				isloopRunning = false;
				endinitCRSConversionToWGS84CRS();
			}
		});
};

const runloop = async (site) => {
	if (!isloopRunning) {
		if (requestDataQueueFIFO.length > 0) {
			isloopRunning = true;
			if (!isTransformerActive) {
				openWebSocketIfClosed().then(() => {
					initCRSConversionToWGS84(site).finally(() => {
						const data = requestDataQueueFIFO.shift();
						recursive(data);
					});
				});
			} else {
				const data = requestDataQueueFIFO.shift();
				recursive(data);
			}
		}
	}
};

const getCoordinatesToWGS84CrsConversion = (site) => {
	//{x,y,z}[]
	//epsg
	const epsg = site.epsg;
	const epsg_v = site.epsg_v;

	//proj string
	const rotation = site.rotation;
	const origin_easting = site.origin_easting;
	const origin_northing = site.origin_northing;
	const origin_latitude = site.origin_latitude;
	const origin_longitude = site.origin_longitude;
	const scale_factor = site.scale_factor;
	const vertical_offset = site.vertical_offset;
	const incline_x = site.incline_x;
	const incline_y = site.incline_y;

	let data;

	if (!(epsg === null || epsg === undefined || epsg === "")) {
		data = {
			from: `${epsg}` + (epsg_v ? `+${epsg_v}` : ""),
			to: "EPSG:4978",
		};
	}

	if (!data) {
		if (!(rotation === null || rotation === "" || rotation === undefined)) {
			data = {
				stereoParameters: [
					`rotation=${rotation}`,
					`origin_easting=${origin_easting}`,
					`origin_northing=${origin_northing}`,
					`origin_latitude=${origin_latitude}`,
					`origin_longitude=${origin_longitude}`,
					`scale_factor=${scale_factor}`,
					`vertical_offset=${vertical_offset}`,
					`incline_x=${incline_x}`,
					`incline_y=${incline_y}`,
				],
				stereoParametersKeyword: "--local-to-wgs84",
				to: "EPSG:4978",
				from: "EPSG:4326+ESRI:115700",
			};
		}
	}
	return data;
};

export const initCRSConversionToWGS84 = (site) => {
	return new Promise((resolve, reject) => {
		if (!wsConvertToWGS84) {
			reject("websocket is not active");
		}
		const data = getCoordinatesToWGS84CrsConversion(site);
		if (data) {
			wsConvertToWGS84.send(
				JSON.stringify({
					eventName: "LAUNCHING_APP",
					data: data,
				}),
			);
		} else {
			reject();
		}
		appLaumchPromiseResolve = resolve;
	});
};

const timeout = 200 * 10 * 60; //2 seconds
const endinitCRSConversionToWGS84CRS = debounce(() => {
	if (!isloopRunning) {
		if (wsConvertToWGS84) {
			wsConvertToWGS84.send(
				JSON.stringify({
					eventName: "CLOSING_APP",
				}),
			);
		} else {
			console.warn("Websocket is not available");
		}
	}
}, timeout);

export const convertPointsToWGS84CRS = async (points, site, replaceable) => {
	for (let i = 0; i < requestDataQueueFIFO.length - 1; ++i) {
		if (
			requestDataQueueFIFO[i].replaceable &&
			!requestDataQueueFIFO[i].replaceable.isOnProcessing
		) {
			requestDataQueueFIFO[i].replaceable.reject();
			requestDataQueueFIFO.splice(i, 1);
			--i;
		}
	}
	const reqPromise = new Promise((resolve, reject) => {
		requestDataQueueFIFO.push({
			points,
			replaceable,
			resolve,
			reject,
			isOnProcessing: false,
		});
	});

	runloop(site);
	return reqPromise;
};

const openWebSocketIfClosed = async () => {
	if (!wsConvertToWGS84) {
		console.warn("wsConvertToWGS84 is not initialized");
		return;
	}
	if (wsConvertToWGS84.readyState === 2 || wsConvertToWGS84.readyState === 3) {
		//closing or closed
		await initWebSocket(wsServerUrl);
	}
};
